import { endpoints } from "../ApiEndPoints/apiEndPoints";
import { getRequestApiMasterData as getRequestApiData } from "../Redux/Hooks/useGetApi";
import { consolelog } from "../helpers/consolelog";

export const pageCountValidation = (totalCount: number | undefined, queryPageSize: number | undefined) => {
  if (totalCount === undefined || queryPageSize === undefined) {
    return 0;
  } else {
    return Math.ceil(totalCount / queryPageSize)
  }
}

export const loadAutoCompleteOptions = (searchedProperty: string, 
  searchedValue: any, 
  apiPath: string, selectedField: string, additionalFilter:string) => {
  if (searchedValue != "") {
    let filter = "";
    if(additionalFilter===""){
      filter = `contains(tolower(${searchedProperty}), '${searchedValue?.toLowerCase()}')`
    }else {
      filter = `contains(tolower(${searchedProperty}), '${searchedValue?.toLowerCase()}') and ${additionalFilter}`
    }
    const params = {
      service: endpoints.getResult(apiPath),
      skip: 0,
      take: 0,
      isEnabled: true,
      filter: filter,
      key: ``,
      onError(error: any) {
        consolelog(error)
      },
      onSuccess(result: any) {
        consolelog(result)
      },
    }
    return getRequestApiData(params).then((response: any) =>
      response?.data?.value?.map((item: any) => (
        {
          label: `${item[selectedField]?.toString()}`,
          value: { desc: item[selectedField]?.toString() },
          data: { ...item }
        })
      ))
  }
}

export const loadOptions = (apiPath: string, valueField: string, isEnabled: boolean) => {
  const params = {
    service: endpoints.getResult(apiPath),
    skip: 0,
    take: 0,
    isEnabled: isEnabled,
    filter: "",
    key: ``,
    onError(error: any) {
      consolelog(error)
    },
    onSuccess(result: any) {
      consolelog(result)
    },
  }

  return getRequestApiData(params).then((response: any) =>
    response?.data?.value?.map((item: any) => (
      {
        label: `${item[valueField]?.toString()}`,
        value: `${item[valueField]?.toString()}`,
        //value: { desc: item[valueField]?.toString() },
        //data:{...item}
      })
    ))
}
export const getData = (apiPath: string, filter: string,
  isEnabled: boolean, skip: number, take: number, key:string) => {
  if (apiPath !== undefined) {
    const params = {
      service: endpoints.getResult(apiPath),
      skip: skip,
      take: take,
      isEnabled: isEnabled,
      filter: filter,
      key: key,
      onError(error: any) {
        consolelog(error)
      },
      onSuccess(result: any) {
        consolelog(result)
      },
    }

    return getRequestApiData(params).then((response: any) =>
      response?.data?.value?.map((item: any) => (
        {
          data: { ...item }
        })
      ))
  }

}
